import { createContext, useContext } from 'react';
import { useParams } from 'react-router-dom';

/** The campaign an embedded builder is editing, for steps that would otherwise read the route. */
export const CampaignEntityContext = createContext<string | undefined>(undefined);

export const useCampaignId = (): string | undefined => {
  const { id } = useParams<{ id: string }>();
  const embeddedId = useContext(CampaignEntityContext);
  return id ?? embeddedId;
};

export default useCampaignId;
